import createCommonEntitySettings from 'client/pages/createCommonEntitySettings'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import EntityInterface from 'common/types/entities/EntityInterface'
import React from 'react'
import { WebsiteMenuSettings } from 'src/editor/shared/settings/menu-settings/website-menu-settings'
import { MenuInterface } from 'src/shared/types/entities/menu'

export const createWebsiteEntitySettings = (
  entity: EntityInterface,
  defaultEntity?: EntityInterface,
) => {
  switch (entity.type) {
    case EntityTypeEnum.Menu:
      return <WebsiteMenuSettings entity={entity as MenuInterface} />
    default:
      return createCommonEntitySettings(entity, defaultEntity)
  }
}
